export default [
  { label: 'Select a service branch...', value: '' },
  { label: 'US Navy', value: 'US Navy' },
  { label: 'US Army', value: 'US Army' },
  { label: 'US Air Force', value: 'US Air Force' },
  { label: 'US Marine Corps', value: 'US Marine Corps' },
  { label: 'US Coast Guard', value: 'US Coast Guard' },
  { label: 'Air National Guard', value: 'Air National Guard' },
  { label: 'National Guard', value: 'National Guard' },
  { label: 'Other', value: 'Other' }
]
